import { AttributesMixin, Collection, define, Store, type } from "@type-r/models"
import { NotificationSubscription } from "../../api/notificationSubscription";
import { NotificationSubscriptionPage } from "../../api/notificationSubscriptionPage";
import { NotificationSubscriptionsFilters } from "./notification-subscriptions-filters"

export interface NotificationSubscriptionsStore extends AttributesMixin<typeof NotificationSubscriptionsStore> { }
@define
export class NotificationSubscriptionsStore extends Store {
    static attributes = {
        page: NotificationSubscriptionPage,
        selected: Collection.ofRefs(NotificationSubscription),
        filter: type(NotificationSubscriptionsFilters)
    }

    async initialize() {
        return Promise.resolve();
    }

    async fetchNotificationSubscriptions() {
        const params = this.filter.mapToQuery(0, 1000);
        await this.page.fetch({ params: params }).catch(e => console.error(e));
    }
}
